import { useState } from "react";
import { PopupMain } from "../../../components/popup/PopupMain";
import numeral from "numeral";
import { STYLE_PADDING_BALANCE_DRAWER } from "../../../utils/useStyle";
import { ExceptionLists, IncomeAfterCal } from "../../../functions/taxFucntion/taxHeirachy";
import { cn } from "../../../utils/useFunctions";
import {
  STYLE_PAGE,
  STYLE_PDF_TEXT_MEDIUM_11,
  STYLE_PDF_TEXT_MEDIUM_12,
  STYLE_PDF_TEXT_MEDIUM_BLUE_11,
  STYLE_PDF_TEXT_MEDIUM_BLUE_12,
} from "../styles/pdf.style";
import PdfHeader from "../component/pdf.c.header";
import { PdfHeaderText } from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import { PdfCard, PdfCardGray, PdfCardWhite } from "../component/pdf.c.card";
import PdfFooter from "../component/pdf.c.footer";

const TaxExceptionPDF = ({
  page,
  total,
  totalException,
  total_name = "รวม",
  head_1 = "รายการ",
  head_2 = "จำนวนเงินที่ได้รับ (บาท)",
  title="ค่าลดหย่อนก่อนวางแผน",
  positionHead = "text-left ",
  subHead = false,
  subhead_name,
  positiontitle = "text-left font-semibold flex text-[11px] ",
  positionnvalue_1 = "text-right font-semibold text-[11px]",
  positionnvalue_2 = "text-right font-semibold text-[11px]",
  displayPart = ["Deduction", "Exception"],
  etc,
  etc_text,
  cols = 3,
  data = [],
  form = {},
}) => {
  const [openInfoPopUp, setOpenInfoPopUp] = useState(false);
  const [openPopUpDonate, setOpenPopUpDonate] = useState(false);
  const [openPopUpAnualty, setOpenPopUpAnualty] = useState(false);

  let sumDeduction = 0;

  return (
    <>
      <div className={cn(STYLE_PAGE)}>
        <PdfHeader />
        <PdfLine />
        <PdfHeaderText
          title="วางแผนภาษี"
          icon="/images/tax_plan.svg"
          classNameIcon="w-[24px] h-[27px]"
        />
        <PdfCard className={"flex flex-col space-y-3"} classNameTitle={"font-semibold text-md "} title={title}>

          <PdfCardWhite className={cn("px-3")}>
            {displayPart?.includes("Exception") && (
              <>
                <div
                  className={` grid grid-cols-${cols} mb-2.5 p-2.5 gap-[5px] mt-[30px] rounded-[10px] text-mainblue text-[11px] font-semibold  bg-blueopacity `}
                >
                  {cols === 2 ? (
                    ""
                  ) : (
                    <div className={""}>
                      {"รายละเอียดเงินได้ที่ได้รับการยกเว้น"}
                    </div>
                  )}
                  <div
                    className={`${positionHead} ${
                      cols === 2 ? "" : "text-right"
                    } `}
                  >
                    {head_1}
                  </div>
                  <div className="text-right font-medium">{head_2}</div>
                </div>
                {data?.map((item, index) => {
                  if (
                    ExceptionLists.includes(item?.title) &&
                    item?.value !== 0 &&
                    item?.value !== undefined
                  ) {
                    return (
                      <div
                        key={index}
                        className={` grid grid-cols-${cols} gap-[5px] text-sm px-2.5 mb-[10px] font-medium`}
                      >
                        <div className={`${positiontitle}`}>
                          {item?.title}
                        </div>

                        <div
                          className={`${positionnvalue_1}`}
                        >
                          {item?.value === ""
                            ? ""
                            : numeral(item?.value).format("0,0")}
                        </div>
                        {cols === 2 ? (
                          ""
                        ) : (
                          <div
                            className={`${positionnvalue_2}`}
                          >
                            {numeral(item?.value2).format("0,0")}
                          </div>
                        )}
                      </div>
                    );
                  }

                  if (item?.title === "เงินสะสมกองทุนสำรองเลี้ยงชีพ") {
                    return (
                      <div
                        key={index}
                        className={` grid grid-cols-${cols} gap-[5px] text-sm px-2.5 mb-[10px] font-medium`}
                      >
                        <div className={`${positiontitle}`}>
                          {item?.title}
                        </div>

                        <div
                          className={`${positionnvalue_1}`}
                        >
                          {numeral(item?.value).format("0,0")}
                        </div>
                        {cols === 2 ? (
                          ""
                        ) : (
                          <div
                            className={`${positionnvalue_2}`}
                          >
                            {item?.value2 >= 10000
                              ? numeral(item?.value2 - 10000).format("0,0")
                              : numeral(item?.value2).format("0,0")}
                          </div>
                        )}
                      </div>
                    );
                  }
                })}
                <div className=" grid grid-cols-2 gap-[5px] items-center text-sm px-2.5 mt-10 font-medium">
                  <div>{total_name}</div>
                  <div className=" text-right text-lg font-bold text-mainblue">
                    {`${numeral(totalException).format('0,0')} บาท`} 
                  </div>
                </div>
              </>
            )}
          </PdfCardWhite>
        </PdfCard>
        <PdfFooter page={page} />
      </div>
    </>
  );
};

export default TaxExceptionPDF;
